"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9169],{

/***/ 19169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Layout_Miniplayer; },
  "miniplayerController": function() { return /* binding */ miniplayerController; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/services/tvSchedule.ts + 4 modules
var tvSchedule = __webpack_require__(73846);
// EXTERNAL MODULE: ./src/services/tvScheduleConfiguration.ts
var tvScheduleConfiguration = __webpack_require__(15935);
// EXTERNAL MODULE: ./src/utils/reactQuery.tsx
var reactQuery = __webpack_require__(4766);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(10763);
// EXTERNAL MODULE: ./src/components/player/index.tsx + 30 modules
var components_player = __webpack_require__(44732);
// EXTERNAL MODULE: ./node_modules/@react-hook/merged-ref/dist/module/index.js
var dist_module = __webpack_require__(27006);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./node_modules/@summer/jst-react-icon/lib/index.js
var lib = __webpack_require__(55537);
;// CONCATENATED MODULE: ./src/components/icons/Unmuted.tsx




var Unmuted = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.9188 0V64L18.377 45.6897H1V18.3103H18.377L41.9188 0ZM37.1048 9.84283L20.0287 23.1242H5.81397V40.8758H20.0287L37.1048 54.1572V9.84283Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53.1928 22.8228V41.176H48.3788V22.8228H53.1928Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M62.2189 18.3096V45.689H57.4049V18.3096H62.2189Z"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/icons/Muted.tsx




var Muted = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.2402 1V62.3746L16.6641 44.8155H0V18.5592H16.6641L39.2402 1ZM34.6237 10.4391L18.2481 23.1757H4.61649V40.199H18.2481L34.6237 52.9356V10.4391Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M57.5081 31.687L64 25.195L60.7357 21.9307L54.2437 28.4226L47.7518 21.9307L44.4874 25.195L50.9794 31.687L44.4874 38.1789L47.7518 41.4433L54.2437 34.9513L60.7357 41.4433L64 38.1789L57.5081 31.687Z"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/icons/Close.tsx
var Close = __webpack_require__(34039);
// EXTERNAL MODULE: ./src/hooks/useUserHealthcareLegalConsent.ts
var useUserHealthcareLegalConsent = __webpack_require__(32962);
// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var react_t7e_lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/player/playerId.ts
var player_playerId = __webpack_require__(19295);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
;// CONCATENATED MODULE: ./src/components/common/Layout/Miniplayer/MiniplayerHeader.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5px 9px;\n  background: ",
        ";\n  color: ",
        ";\n\n  font-size: 12px;\n  font-weight: 300;\n  line-height: 18px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MiniplayerHeader__Header",
    componentId: "sc-c622ae6a-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var MiniplayerHeader = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var playerId = _param.playerId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "playerId"
    ]);
    var _ = (0,react_t7e_lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: (playerId === null || playerId === void 0 ? void 0 : playerId.includes(player_playerId/* PlayerId.TVLike */.z.TVLike)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                children: _("NEAUVIA TV")
            })
        }))
    });
});
MiniplayerHeader.displayName = "MiniplayerHeader";

;// CONCATENATED MODULE: ./src/components/common/Layout/Miniplayer/MiniplayerPlayerControls.tsx

function MiniplayerPlayerControls_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  background: ",
        ";\n  color: ",
        ";\n  ",
        " {\n    padding-right: 24px;\n    height: 70px;\n  }\n"
    ]);
    MiniplayerPlayerControls_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  width: 100%;\n  ",
        " {\n    align-items: flex-start;\n    min-height: 66px;\n    padding: 10px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  ",
        ";\n  ",
        " {\n    font-size: 12px;\n    line-height: 14px;\n    text-transform: uppercase;\n    flex: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  ",
        " {\n    font-size: 10px;\n    padding: 0 0 0 10px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  padding: 5px;\n  color: ",
        ";\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
















var Wrapper = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "MiniplayerPlayerControls__Wrapper",
    componentId: "sc-7a49e2ed-0"
})(MiniplayerPlayerControls_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MiniplayerPlayerControls__Container",
    componentId: "sc-7a49e2ed-1"
})(_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var VideoTitle = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "MiniplayerPlayerControls__VideoTitle",
    componentId: "sc-7a49e2ed-2"
})(_templateObject2(), (0,common/* lineClamp */.Sf)(2), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ConsentText = (0,styled_components_browser_esm["default"])(VideoTitle).withConfig({
    displayName: "MiniplayerPlayerControls__ConsentText",
    componentId: "sc-7a49e2ed-3"
})(_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ControlButton = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "MiniplayerPlayerControls__ControlButton",
    componentId: "sc-7a49e2ed-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledMiniplayerHeader = (0,styled_components_browser_esm["default"])(MiniplayerHeader).withConfig({
    displayName: "MiniplayerPlayerControls__StyledMiniplayerHeader",
    componentId: "sc-7a49e2ed-5"
})(_templateObject5(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
// eslint-disable-next-line react/display-name
var MiniplayerPlayerControls = /*#__PURE__*/ (0,react.memo)(function(param) {
    var video = param.video, isMuted = param.isMuted, playerId = param.playerId, onReturn = param.onReturn, toggleMute = param.toggleMute, onClose = param.onClose;
    var _ = (0,react_t7e_lib.useTranslate)()._;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var translatedVideo = video ? translateItem(video) : null;
    var isDesktop = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
    var userConsentValue = (0,useUserHealthcareLegalConsent/* useUserHealthcareLegalConsent */.P)().userConsentValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                userConsentValue || isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoTitle, {
                            onClick: onReturn,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMiniplayerHeader, {
                                    playerId: playerId
                                }),
                                translatedVideo === null || translatedVideo === void 0 ? void 0 : translatedVideo.name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButton, {
                            onClick: toggleMute,
                            children: isMuted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Muted, {
                                size: 23
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Unmuted, {
                                size: 23
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsentText, {
                    onClick: onReturn,
                    children: _("MEDICAL CONTENT CONFIRMATION OF PROFESSION REQUIRED")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlButton, {
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* Close */.x, {
                        size: 20
                    })
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./src/components/common/Layout/Miniplayer/MiniplayerPlayer.tsx

function MiniplayerPlayer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n\n  ",
        " {\n    display: flex;\n\n    .neauvia-player {\n      width: 192px;\n      height: 70px;\n      padding: 0;\n    }\n  }\n\n  ",
        " {\n    .player__mute-overlay {\n      --base-unit: min(100vw, 1300rpx) / 1366;\n    }\n  }\n"
    ]);
    MiniplayerPlayer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MiniplayerPlayer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    MiniplayerPlayer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var MiniplayerPlayer_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MiniplayerPlayer__Container",
    componentId: "sc-bca5a463-0"
})(MiniplayerPlayer_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.background;
}, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var MiniplayerPlayer_StyledMiniplayerHeader = (0,styled_components_browser_esm["default"])(MiniplayerHeader).withConfig({
    displayName: "MiniplayerPlayer__StyledMiniplayerHeader",
    componentId: "sc-bca5a463-1"
})(MiniplayerPlayer_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
// eslint-disable-next-line react/display-name
var MiniplayerPlayer = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var playerId = param.playerId, video = param.video, playFrom = param.playFrom, wistiaOptions = param.wistiaOptions, loop = param.loop, onReturn = param.onReturn, onClose = param.onClose, onPlay = param.onPlay, onPause = param.onPause, onEnded = param.onEnded;
    var player = (0,react.useRef)(null);
    var mergedPlayerRef = (0,dist_module/* default */.Z)(ref, player);
    var isMobile = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
    var _$ref = (0,react.useState)(true), isMuted = _$ref[0], setIsMuted = _$ref[1];
    var playerControls = (0,react.useMemo)(function() {
        return {
            native: {
                enabled: !isMobile
            },
            shortcodes: {
                enabled: false
            },
            relatedVideos: {
                enabled: false
            },
            userActions: {
                enabled: false
            },
            miniplayerActions: {
                enabled: true,
                onReturn: onReturn,
                onClose: onClose
            },
            healthcareConsent: {
                enabled: true,
                backgroundOnly: isMobile,
                onBackgroundClick: isMobile ? onReturn : undefined
            },
            mdrDisclaimer: {
                enabled: !isMobile
            }
        };
    }, [
        isMobile,
        onReturn,
        onClose
    ]);
    var onReady = (0,react.useCallback)(function(state) {
        return setIsMuted(state.muted);
    }, [
        setIsMuted
    ]);
    var onMute = (0,react.useCallback)(function() {
        return setIsMuted(true);
    }, [
        setIsMuted
    ]);
    var onUnmute = (0,react.useCallback)(function() {
        return setIsMuted(false);
    }, [
        setIsMuted
    ]);
    var toggleMute = (0,react.useCallback)(function() {
        var _$ref, _$ref1;
        return isMuted ? (_$ref = player.current) === null || _$ref === void 0 ? void 0 : _$ref.unmute() : (_$ref1 = player.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.mute();
    }, [
        isMuted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniplayerPlayer_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerPlayer_StyledMiniplayerHeader, {
                playerId: playerId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_player/* NeauviaMiniplayerPlayer */.Oh, {
                ref: mergedPlayerRef,
                ar: 16 / 9,
                playerId: playerId,
                video: video,
                playFrom: playFrom,
                autoPlay: true,
                loop: loop,
                controls: playerControls,
                onReady: onReady,
                onMute: onMute,
                onUnmute: onUnmute,
                wistiaOptions: wistiaOptions,
                onPlay: onPlay,
                onPause: onPause,
                onEnded: onEnded
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerPlayerControls, {
                video: video,
                playerId: playerId,
                isMuted: isMuted,
                onReturn: onReturn,
                onClose: onClose,
                toggleMute: toggleMute
            })
        ]
    });
}));

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/store/miniplayer/selectors.ts
var selectors = __webpack_require__(95406);
// EXTERNAL MODULE: ./src/store/actions.ts + 1 modules
var actions = __webpack_require__(88776);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/modules/home/components/HomeTVSection/common.tsx
var HomeTVSection_common = __webpack_require__(77917);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(25849);
;// CONCATENATED MODULE: ./src/components/common/Layout/Miniplayer/MiniplayerTVPlayer.tsx









var wistiaOptions = {
    playbar: false,
    playSuspendedOffScreen: false,
    smallPlayButton: false,
    playButton: false
};
// eslint-disable-next-line react/display-name
var MiniplayerTVPlayer = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var onReturn = param.onReturn, onClose = param.onClose;
    var player = (0,react.useRef)(null);
    var mergedRef = (0,dist_module/* default */.Z)(player, ref);
    var _$ref = (0,tvSchedule/* useTVScheduleQuery */.Vn)(), schedule = _$ref.data;
    var _$ref1 = (0,tvScheduleConfiguration/* useTVScheduleConfigurationQuery */.T)(), scheduleConfiguration = _$ref1.data;
    var currentVideo = (0,tvSchedule/* useCurrentTVSectionItem */.UL)(schedule, scheduleConfiguration).currentVideo;
    var liveOnPlayCallback = (0,HomeTVSection_common/* useLiveOnPlayCallback */._)(currentVideo, player);
    var handleClose = (0,react.useCallback)(function() {
        storage/* sessionStorage.setItem */.y.setItem("nc_tv-miniplayer-closed", "true");
        onClose();
    }, [
        onClose
    ]);
    if (currentVideo == null) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerPlayer, {
        ref: mergedRef,
        playerId: player_playerId/* PlayerId.TVLike */.z.TVLike,
        video: currentVideo.video,
        playFrom: currentVideo.playFrom,
        onReturn: onReturn,
        onClose: handleClose,
        loop: true,
        wistiaOptions: wistiaOptions,
        onPlay: liveOnPlayCallback
    });
}));

// EXTERNAL MODULE: ./src/components/common/Layout/Miniplayer/useMiniplayerAutoOpen.tsx
var useMiniplayerAutoOpen = __webpack_require__(93771);
;// CONCATENATED MODULE: ./src/components/common/Layout/Miniplayer/index.tsx



function Miniplayer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  bottom: calc(var(--footer-fixed-height) + 20rpx);\n  right: 20rpx;\n  width: 375px;\n  z-index: 49;\n  background: #ffffff;\n  box-shadow: 0 3px 6px #4b4b4b28;\n  transition: bottom 0.25s;\n  ",
        " {\n    right: auto;\n    left: 20rpx;\n  }\n\n  ",
        " {\n    width: 100%;\n    max-width: 100vw;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: var(--footer-fixed-height);\n    box-shadow: 0px -1px 6px #4b4b4b28;\n  }\n\n  ",
        " {\n    .player__consent-block {\n      gap: 15px;\n      width: calc(100% - 60px);\n      & > div {\n        font-size: 16px;\n      }\n      & > button {\n        min-height: 40px;\n      }\n    }\n  }\n"
    ]);
    Miniplayer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



















var Miniplayer_Wrapper = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "Miniplayer__Wrapper",
    componentId: "sc-ed8f052a-0"
})(Miniplayer_templateObject(), theme/* dirRTL */.gX, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var transition = (0,transitions/* makeTransition */.Vr)({
    from: "bottom",
    to: "bottom",
    fade: true,
    enterDelay: 0.2
});
var miniplayerController = {};
var Miniplayer = (0,reactQuery/* withQueries */.kS)({
    schedule: tvSchedule/* useTVScheduleQuery */.Vn,
    scheduleConfiguration: tvScheduleConfiguration/* useTVScheduleConfigurationQuery */.T
}, function() {
    var player = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var currentMiniplayer = (0,es/* useSelector */.v9)(selectors/* selectMiniplayerCurrent */.kD);
    var currentOnReturn = (0,es/* useSelector */.v9)(selectors/* selectMiniplayerOnReturn */.Ix);
    var isTVLike = currentMiniplayer === null || currentMiniplayer === void 0 ? void 0 : currentMiniplayer.playerId.includes(player_playerId/* PlayerId.TVLike */.z.TVLike);
    var onReturn = (0,react.useCallback)(function() {
        var ref;
        if (currentMiniplayer == null) {
            return;
        }
        var playerState = (ref = player.current) === null || ref === void 0 ? void 0 : ref.stateSnapshot;
        var state = {
            playing: playerState === null || playerState === void 0 ? void 0 : playerState.playing,
            playFrom: playerState === null || playerState === void 0 ? void 0 : playerState.time,
            muted: playerState === null || playerState === void 0 ? void 0 : playerState.muted,
            volume: playerState === null || playerState === void 0 ? void 0 : playerState.volume
        };
        if (currentOnReturn != null) {
            dispatch(actions/* AppAction.resetMiniplayer */.q.resetMiniplayer({}));
            setTimeout(function() {
                return currentOnReturn(state);
            }, 0);
        } else {
            dispatch(actions/* AppAction.snapshotMiniplayer */.q.snapshotMiniplayer((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                playerId: currentMiniplayer.playerId
            })));
            if (currentMiniplayer.playerId.includes(player_playerId/* PlayerId.Common */.z.Common) && currentMiniplayer.video != null) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                router.replace(route/* route.video */.BC.video(currentMiniplayer.video).page());
            } else if (isTVLike) {
                router.replace(route/* route.homepage */.BC.homepage());
            }
        }
    }, [
        router,
        dispatch,
        currentMiniplayer,
        isTVLike,
        currentOnReturn
    ]);
    var onClose = (0,react.useCallback)(function() {
        return dispatch(actions/* AppAction.resetMiniplayer */.q.resetMiniplayer({}));
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        miniplayerController.return = function() {
            return onReturn();
        };
        miniplayerController.close = function() {
            return onClose();
        };
        return function() {
            delete miniplayerController.return;
            delete miniplayerController.close;
        };
    }, [
        onReturn,
        onClose
    ]);
    (0,useMiniplayerAutoOpen/* useMiniplayerAutoOpen */.q)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
        children: [
            currentMiniplayer && !isTVLike && /*#__PURE__*/ (0,jsx_runtime.jsx)(Miniplayer_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transition), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerPlayer, {
                    ref: player,
                    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */ video: currentMiniplayer.video,
                    onReturn: onReturn,
                    onClose: onClose
                })
            })),
            currentMiniplayer && isTVLike && /*#__PURE__*/ (0,jsx_runtime.jsx)(Miniplayer_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transition), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerTVPlayer, {
                    ref: player,
                    onReturn: onReturn,
                    onClose: onClose
                })
            }))
        ]
    });
});
/* harmony default export */ var Layout_Miniplayer = (Miniplayer);


/***/ }),

/***/ 93771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ hasMiniplayerBeenClosed; },
/* harmony export */   "q": function() { return /* binding */ useMiniplayerAutoOpen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20414);
/* harmony import */ var _summer_jst_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72559);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_modules_events_hooks_useEventDetailsQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43969);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_services_route__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38325);
/* harmony import */ var src_hooks_useTimeState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12597);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var src_store_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88776);
/* harmony import */ var src_components_player_playerId__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19295);
/* harmony import */ var src_utils_storage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25849);













var hasMiniplayerBeenClosed = function() {
    return !!src_utils_storage__WEBPACK_IMPORTED_MODULE_9__/* .sessionStorage.getItem */ .y.getItem("nc_tv-miniplayer-closed");
};
var useMiniplayerAutoOpen = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var clientReady = (0,_summer_jst_react__WEBPACK_IMPORTED_MODULE_0__/* .useClientReady */ .t0)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var _slug;
    var eventQuery = (0,src_modules_events_hooks_useEventDetailsQuery__WEBPACK_IMPORTED_MODULE_2__/* .useEventDetailsQuery */ .U)((_slug = router.query.slug) !== null && _slug !== void 0 ? _slug : "", false);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!clientReady) {
            return;
        }
        var autoOpen = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
                var disallowedInitialRoutes, ref, event;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            disallowedInitialRoutes = [
                                src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .route.homepage */ .BC.homepage()
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .videoPageRoutes */ .TG), [
                                src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .Route.EventsEpisodesPage */ .AW.EventsEpisodesPage,
                                src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .Route.EventsEpisodesItemPage */ .AW.EventsEpisodesItemPage,
                                src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .Route.EventsDetailsPage */ .AW.EventsDetailsPage
                            ]);
                            if (!(src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .eventPageRoute */ .ly === router.route)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                eventQuery.refetch()
                            ];
                        case 1:
                            ref = _state.sent(), event = ref.data;
                            if (event && event.videos[0] && (0,src_hooks_useTimeState__WEBPACK_IMPORTED_MODULE_5__/* .isTimeNow */ .LG)(event)) {
                                disallowedInitialRoutes.push(src_services_route__WEBPACK_IMPORTED_MODULE_4__/* .eventPageRoute */ .ly);
                            }
                            _state.label = 2;
                        case 2:
                            if (clientReady && !disallowedInitialRoutes.includes(router.route) && !hasMiniplayerBeenClosed()) {
                                dispatch(src_store_actions__WEBPACK_IMPORTED_MODULE_7__/* .AppAction.openMiniplayer */ .q.openMiniplayer({
                                    playerId: src_components_player_playerId__WEBPACK_IMPORTED_MODULE_8__/* .PlayerId.TVLike */ .z.TVLike
                                }));
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function autoOpen() {
                return _ref.apply(this, arguments);
            };
        }();
        autoOpen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientReady
    ]);
};


/***/ }),

/***/ 67062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ eventsGqlFragment; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72493);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment events on events {\n    id\n    slug\n    form\n    reach\n    startDate\n    endDate\n    background\n    pastCtaLink\n    upcomingCtaLink\n    mailchimpTag\n    logo {\n      id\n    }\n    image {\n      id\n    }\n    translations {\n      howToParticipate\n      upcomingCtaLabel\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n    tags {\n      tags_id {\n        id\n        slug\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    type {\n      id\n      background\n      image {\n        id\n      }\n      logo {\n        id\n      }\n      translations {\n        description\n        excerpt\n        name\n        languages_code {\n          code\n        }\n      }\n      tags {\n        tags_id {\n          id\n          slug\n          translations {\n            name\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var eventsGqlFragment = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());


/***/ }),

/***/ 43969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ useEventDetailsQuery; }
});

// UNUSED EXPORTS: fetchEventDetails

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/modules/events/graphql/events.fragment.ts
var events_fragment = __webpack_require__(67062);
// EXTERNAL MODULE: ./src/modules/videos/graphql/videos-basic.fragment.ts
var videos_basic_fragment = __webpack_require__(3273);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-details.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  ",
        '\n  query EventDetails($filters: events_filter, $sort: [String]) {\n    events(filter: $filters, sort: $sort, limit: -1) {\n      ...events\n      seoImage {\n        id\n      }\n      videos {\n        videos_id {\n          ...videosBasic\n        }\n      }\n      speakers {\n        people_id {\n          name\n          portrait {\n            id\n          }\n          translations {\n            title\n            degree\n            description\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n      subEvents {\n        id\n      }\n      faq(sort: ["sort"]) {\n        eventFaq_id {\n          translations {\n            answer\n            question\n            languages_code {\n              code\n            }\n          }\n        }\n      }\n    }\n  }\n'
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var eventDetailsGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject(), events_fragment/* eventsGqlFragment */.g, videos_basic_fragment/* videosBasicFragment */.B);

;// CONCATENATED MODULE: ./src/modules/events/hooks/useEventDetailsQuery.ts







var fetchEventDetails = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis, slug) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(eventDetailsGqlQuery, {
                            filters: {
                                slug: {
                                    _eq: slug
                                },
                                status: {
                                    _eq: "published"
                                }
                            }
                        }).then(function(a) {
                            return a.events[0];
                        })
                    ];
            }
        });
    });
    return function fetchEventDetails(apis, slug) {
        return _ref.apply(this, arguments);
    };
}();
var useEventDetailsQuery = function(slug, enabled) {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)((0,_to_consumable_array/* default */.Z)(query/* QueryKey.EventPage */.S.EventPage).concat([
        slug
    ]), function() {
        return fetchEventDetails(apis, slug);
    }, {
        enabled: enabled
    });
};


/***/ }),

/***/ 77917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useLiveOnPlayCallback; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var src_utils_time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73395);
/* harmony import */ var src_services_tvSchedule__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73846);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_modules_videos_utils_isLiveStream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81467);






var useLiveOnPlayCallback = function(currentVideo, playerApi) {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        var time, playingFrom;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.schedule) != null && playerApi.current != null)) return [
                        3,
                        3
                    ];
                    if (!(0,src_modules_videos_utils_isLiveStream__WEBPACK_IMPORTED_MODULE_3__/* .isLiveStream */ .t)(currentVideo.video)) return [
                        3,
                        1
                    ];
                    setTimeout(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        var ref;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                            (ref = playerApi.current) === null || ref === void 0 ? void 0 : ref.seekTo(Number.MAX_SAFE_INTEGER);
                            return [
                                2
                            ];
                        });
                    }), 0);
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        src_utils_time__WEBPACK_IMPORTED_MODULE_0__/* .currentTime$.take */ .P.take(1).toPromise()
                    ];
                case 2:
                    time = _state.sent();
                    playingFrom = (0,src_services_tvSchedule__WEBPACK_IMPORTED_MODULE_1__/* .getLiveTimeOffset */ .TN)(time, currentVideo.schedule);
                    playerApi.current.seekTo(playingFrom);
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [
        currentVideo
    ]);
};


/***/ }),

/***/ 15935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useTVScheduleConfigurationQuery; }
/* harmony export */ });
/* unused harmony export tvScheduleConfigurationQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20414);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19162);
/* harmony import */ var src_utils_gql_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72493);
/* harmony import */ var src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57750);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53100);
/* harmony import */ var src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67561);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  fragment video on videos {\n    id\n    slug\n    thumbnail {\n      id\n    }\n    speakers {\n      people_id {\n        id\n        avatar {\n          id\n        }\n        name\n        translations {\n          degree\n          title\n          languages_code {\n            code\n          }\n        }\n        country {\n          translations {\n            languages_code {\n              code\n            }\n            name\n          }\n        }\n      }\n    }\n\n    shortcodes {\n      ...shortcodes\n    }\n    tags {\n      tags_id {\n        id\n        translations {\n          name\n          languages_code {\n            code\n          }\n        }\n      }\n    }\n    disclaimer\n    source {\n      id\n      url\n      format\n      duration\n      startDate\n      endDate\n    }\n    translations {\n      description\n      excerpt\n      name\n      languages_code {\n        code\n      }\n    }\n  }\n\n  query {\n    tvScheduleConfiguration {\n      prelude {\n        ...video\n      }\n      platformTrailer {\n        ...video\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var tvScheduleGqlQuery = (0,src_utils_gql_query__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject(), src_modules_videos_graphql_videos_shortcodes_fragment__WEBPACK_IMPORTED_MODULE_6__/* .shortcodesGqlFragment */ .U);
var tvScheduleConfigurationQuery = function(apis) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        queryKey: src_models_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryKey.TVScheduleConfiguration */ .S.TVScheduleConfiguration
    }, src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_4__/* .queryCommonOptions.commonHandlers */ .e.commonHandlers, src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_4__/* .queryCommonOptions.longStale */ .e.longStale), {
        queryFn: /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
            var directus;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            apis.directus()
                        ];
                    case 1:
                        directus = _state.sent();
                        return [
                            2,
                            directus.query(tvScheduleGqlQuery).then(function(a) {
                                return a.tvScheduleConfiguration;
                            })
                        ];
                }
            });
        })
    });
};
var useTVScheduleConfigurationQuery = function() {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(tvScheduleConfigurationQuery((0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_5__/* .useAPIs */ .V)()));
};


/***/ })

}]);